import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    {
        cameraLocationId: 'ATR_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Atrium',
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'CHG_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: `Children's Gallery`,
        ObjectId:null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'MAG_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Main Gallery',
        ObjectId:null,
        displayMesh: 'N',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
